import Field from './Field';
import { BLOOD } from '../../constants/adrData';

export default function PersonalInfoSection({ form, errors, onChange }) {
  return (
    <>
      <div className="form-section-label">👤 Personal Information</div>

      <div className="grid-2">
        <Field
          label="Full Name (પૂર્ણ નામ)"
          name="name"
          placeholder="e.g Rahul Sharma"
          required
          value={form.name}
          error={errors.name}
          onChange={onChange}
        />

        <Field
          label="Age (ઉંમર)"
          name="age"
          type="number"
          placeholder="e.g 35"
          value={form.age}
          error={errors.age}
          onChange={onChange}
        />
      </div>

      <div className="grid-2">
        <Field
          label="Gender (જાતિ)"
          name="gender"
          as="select"
          options={['Male (પુરુષ)', 'Female (સ્ત્રી)', 'Other (અન્ય)']}
          value={form.gender}
          error={errors.gender}
          onChange={onChange}
        />

        <Field
          label="Blood Group (રક્ત જૂથ)"
          name="bloodGroup"
          as="select"
          options={BLOOD}
          value={form.bloodGroup}
          error={errors.bloodGroup}
          onChange={onChange}
        />
      </div>

      <div className="grid-2">
        <Field
          label="Phone Number (ફોન નંબર)"
          name="phone"
          type="tel"
          placeholder="10 digit number"
          required
          value={form.phone}
          error={errors.phone}
          onChange={onChange}
        />

        <Field
          label="Hospital Registration No. (હોસ્પિટલ નોંધણી નંબર)"
          name="regNo"
          placeholder="e.g 778790P"
          required
          value={form.regNo}
          error={errors.regNo}
          onChange={onChange}
        />
      </div>

      <Field
        label="Report Date (અહેવાલ તારીખ)"
        name="reportDate"
        type="date"
        value={form.reportDate}
        error={errors.reportDate}
        onChange={onChange}
      />

      <Field
        label="Address (સરનામું)"
        name="address"
        placeholder="Your residential address"
        value={form.address}
        error={errors.address}
        onChange={onChange}
      />
    </>
  );
}
